<template>
  <el-container class="box">
    <el-header class="title" style="height: auto">经费</el-header>
    <el-main style="padding-top:0">
        <div class="bg-border">
            <div class="bg-decorate">
                <div class="sub-description">经费预算</div>
                <div class="sub-title">￥{{countTotalFund}} 万元</div>
            </div>
        </div>
        <div class="bg-border">
            <div class="bg-decorate">
                <div class="sub-description">专项经费</div>
                <div class="sub-title">￥{{countSpecialFund}} 万元</div>
            </div>
        </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  data () {
    return {
      countTotalFund: 0,
      countSpecialFund: 0
    }
  },
  created () {
    this.fetchCountData();
  },
  methods: {
    fetchCountData () {
      this.post('/dataapi/open/nqi/fruit/getTotalFundsInfo').then(res => {
        this.countTotalFund = this.numFormat(res.result);
      });
      this.post('/dataapi/open/nqi/fruit/getTotalSpecialFundsInfo').then(res => {
        this.countSpecialFund = this.numFormat(res.result);
      });
    },
    numFormat (num) {
      var res = num.toString().replace(/\d+/, function (n) { // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
          return $1 + ',';
        });
      })
      return res;
    }
  }
}
</script>

<style lang="less" scoped>
.box{
  background-image: url('../assets/images/contentBg-min.png');
  background-size: 100% 100%;
  width: 100%;
  height: 242px;
}
.title{
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #00FFF4;
  margin: 16px auto 0;
}
.sub-title{
  font-family: SourceHanSansSC-Medium, SourceHanSansSC;
  color: #00FFF4;
  margin: 5px;
  font-size: 22px;
}
.sub-description{
  font-family: SourceHanSansSC-Regular, SourceHanSansSC;
  color: #FFFFFF;
  font-size: 14px;
  padding-top: 15px;
    padding-left: 10px;
}
.bg-border{
  background-image: url('../assets/images/bg-border.png');
  background-size: 100% 100%;
  width: 100%;
  height: 80px;
  margin-top:10px
}
.bg-decorate{
  background-image: url('../assets/images/bg-decorate.png');
  background-size: 100% 100%;
  width: 100%;
  height: 75px;
}
</style>



// WEBPACK FOOTER //
// src/components/fundCount.vue